import trimAndCollapseSpaces from 'helpers/trimAndCollapseSpaces'

const trimObjectValues = <T extends Record<string, unknown>>(
  inputObject: T,
): T => {
  return Object.fromEntries(
    Object.entries(inputObject).map(([key, value]) => [
      key,
      typeof value === 'string' ? trimAndCollapseSpaces(value) : value,
    ]),
  ) as T
}

export default trimObjectValues
